module.exports = __webpack_public_path__ + "img/Progress-Report-3-mobile.af1081a5.png";